import { Star } from "lucide-react";

export const Stars = ({ rating = 5, size = 13, className = "" }) => (
  <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= Math.round(rating) ? "fill-amber-500 text-amber-500" : "fill-neutral-200 text-neutral-200"}
      />
    ))}
  </div>
);
